export function getAccessToken() {
  const storedToken = sessionStorage.getItem("accessToken");
  if (!storedToken) return "";
  try {
    const token = JSON.parse(storedToken);
    return typeof token === "string" ? token : "";
  } catch (error) {
    return storedToken;
  }
}

async function requestWalletInvestmentApi(baseUrl, path, { method = "GET", body, signal } = {}) {
  const token = getAccessToken();
  if (!token) throw new Error("Your sign-in session is missing. Please sign in again.");
  const apiBase = String(baseUrl || "").replace(/\/+$/, "");
  const endpointPath = String(path || "").replace(/^\/+/, "");
  const response = await fetch(`${apiBase}/investments/wallet/${endpointPath}`, {
    method,
    headers: { token, ...(body === undefined ? {} : { "Content-Type": "application/json" }) },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
    signal,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const message = typeof data === "string" ? data : data.message || data.error;
    const error = new Error(message || "The wallet investment service could not complete the request.");
    error.status = response.status;
    throw error;
  }
  return data;
}


export async function getWalletInvestmentPortfolio(baseUrl, options = {}) {
  const data = await requestWalletInvestmentApi(
    baseUrl,
    "portfolio",
    options
  );

  const portfolio = data?.portfolio;

  if (
    !portfolio ||
    typeof portfolio !== "object" ||
    !Number.isFinite(
      Number(portfolio.availableBalance ?? portfolio.cash)
    ) ||
    !Array.isArray(portfolio.holdings) ||
    !Array.isArray(portfolio.history) ||
    !Array.isArray(portfolio.activity)
  ) {
    throw new Error(
      "The wallet service returned incomplete account data. Please try again."
    );
  }

  return {
    ...data,
    portfolio: {
      ...portfolio,
      availableBalance: Number(
        portfolio.availableBalance ?? portfolio.cash
      ),
      currencySymbol:
        typeof portfolio.currencySymbol === "string"
          ? portfolio.currencySymbol.trim()
          : "",
      currencyCode:
        typeof portfolio.currencyCode === "string"
          ? portfolio.currencyCode.trim()
          : "",
    },
  };
}

export async function getWalletInvestmentMarketData(baseUrl, { category = "all", ...options } = {}) {
  const data = await requestWalletInvestmentApi(baseUrl, `market-data?category=${encodeURIComponent(category)}`, options);
  if (!data || !Array.isArray(data.assets)) throw new Error("The investment service returned invalid market data.");
  return data;
}

export function placeWalletInvestmentOrder(baseUrl, body, options = {}) {
  return requestWalletInvestmentApi(baseUrl, "orders", { ...options, method: "POST", body });
}
